module.exports = __webpack_public_path__ + "static/20181002_190426_optimized-06612208163c9311a063c282dec191bc.jpg";